import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";

const LandscapeWhoWeAre = () => {
  const sitedata = useSelector((store) => store.global.loginData);
  const [homeIntroData, setHomeIntroData] = useState({});

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/aboutus");
    setHomeIntroData(response?.data);
  };

  const progressData = [
    { name: "Banking And Financial", percent: 60 },
    { name: "Family Law", percent: 65 },
    { name: "Car Accidents", percent: 80 },
    { name: "Wrongful Death", percent: 70 },
  ];


  return (
    <>
      {homeIntroData &&
        (homeIntroData?.who_we_are_video ||
          homeIntroData?.who_we_are_description) && (
          <div className="row mt-5 d-flex align-items-stretch mb-5">
            <div className="col-lg-6 bg-1 bg-grey pad-tb-30 pad-lr-50 d-flex justify-content-center landscape-who-we-are-text">
              <div className="title-wrap landscape-who-we-are mb-0">
                <div className="section-title margin-bottom-40">
                  <h2 className="title text-uppercase mb-0">
                {homeIntroData?.who_we_are_heading || (
                          <>
                            Who We Are<span className="theme-color"></span>
                          </>
                        )}
                  </h2>
                  <span className="section-border-bottom"></span>
                </div>
              </div>
              <div className="feature-box-wrap f-box-style-1 relative">
                <div className="feature-box-details">
                  <div className="feature-content">
                    <p>
                      <span
                        className="text-black"
                        dangerouslySetInnerHTML={{
                          __html: homeIntroData?.who_we_are_description,
                        }}
                      ></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 p-0 div-bg-img d-flex justify-content-center align-items-center landscape-who-we-are">
              {homeIntroData?.who_we_are_video ? (
                <div
                  className="about-vedio-frame w-100"
                  dangerouslySetInnerHTML={{
                    __html: homeIntroData?.who_we_are_video.replace(
                      /src=\"([^\"]+)\"/,
                      (match, p1) => {
                        const newUrl = new URL(p1);
                        newUrl.searchParams.set("autoplay", "1");
                        newUrl.searchParams.set("rel", "0");
                        newUrl.searchParams.set("mute", "1");
                        return `src="${newUrl.toString()}"`;
                      }
                    ),
                  }}
                />
              ) : homeIntroData?.image ? (
                <div
                  style={{
                    height: "100%",
                    backgroundImage: `url(${homeIntroData.image || "/assets/images/bg/bg-9.jpg"})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                ></div>
              ) : null}
            </div>
          </div>
        )}

    </>
  );
};

export default LandscapeWhoWeAre;
